import script from "./content-header.vue?vue&type=script&lang=ts&setup=true"
export * from "./content-header.vue?vue&type=script&lang=ts&setup=true"

import "./content-header.vue?vue&type=style&index=0&id=31525c6c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31525c6c"]])

export default __exports__